module.exports = __webpack_public_path__ + "img/icon2.a0183a6c.png";